import { render, staticRenderFns } from "./ZenSocialEmbed.vue?vue&type=template&id=269823df&scoped=true"
import script from "./ZenSocialEmbed.vue?vue&type=script&lang=js"
export * from "./ZenSocialEmbed.vue?vue&type=script&lang=js"
import style0 from "./ZenSocialEmbed.vue?vue&type=style&index=0&id=269823df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269823df",
  null
  
)

export default component.exports